// extracted by mini-css-extract-plugin
module.exports =  {"button":"_33974c2b58--button--gs5R_","loading":"_33974c2b58--loading--fC43r","spinner":"_33974c2b58--spinner--rWSqM"};